const downloadFileFromUrl = (document, url) => {
  const aTag = document.createElement('a');
  aTag.href = url;
  aTag.style.display = 'none';
  aTag.setAttribute('download', '');

  document.body.appendChild(aTag);
  aTag.click();

  // Use setTimeout to ensure the browser has time to process the click
  setTimeout(() => {
    document.body.removeChild(aTag);
  }, 100);
};

export default downloadFileFromUrl;
